import moment from 'moment';

class AvailabilityBlockController {

    constructor(availabilityModelService, messageService) {
        this.availabilityModelService = availabilityModelService;
        this.messageService = messageService;
    }

    $onInit () {
        this.buttonText = 'Add Block';
        this.today = moment().format('YYYY-MM-DD');
        this.invalid = true;
    }

    onDateSelect () {
        this.message = null;
        this.invalid = false;
        this.saving = true;
        this.buttonText = 'Add Block';

        return this.availabilityModelService.dateStatus(this.date.format('YYYY-MM-DD'))
            .then(response => {
                this.saving = false;

                if (response && response.status
                    && this.date.format('YYYY-MM-DD') === response.date) {
                    const dateFormatted = moment(response.date).format('LL');

                    switch (response.status) {
                        case 'closed':
                            this.message = `${dateFormatted} is already blocked, if you save, it will remove the block`;
                            this.buttonText = 'Remove Block';
                            break;
                        case 'other':
                            this.message = `${dateFormatted} is already blocked, please use the list view to remove the block if required`;
                            this.invalid = true;
                            break;
                    }
                }
            });
    }

    onSave () {
        if (!this.date) {
            this.message = 'Please select a date before saving';
            return Promise.resolve();
        }

        return this.availabilityModelService.dateToggle(this.date.format('YYYY-MM-DD'));
    }

    onSuccess (response) {
        if (response && response.status) {
            this.message = null;

            switch (response.status) {
                case 'open':
                    this.messageService.success('Block successfully removed');
                    this.messageService.push();
                    this.buttonText = 'Add Block';
                    break;
                case 'closed':
                    this.messageService.success('Block successfully added');
                    this.messageService.push();
                    this.buttonText = 'Remove Block';
                    break;
            }
        }
    }

    onError () {
        this.messageService.failure('An error occurred, please try again or contact RevSpa for assistance');
        this.messageService.push();
    }
}

AvailabilityBlockController.$inject = ['availabilityModelService', 'messageService'];

export default AvailabilityBlockController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/controllers/availability.block.controller.js